import { render, staticRenderFns } from "./SearchBarItem.vue?vue&type=template&id=1c66d318&lang=pug"
import script from "./SearchBarItem.vue?vue&type=script&lang=js"
export * from "./SearchBarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports